<script>
import CasesCommonHeadMobile from "@/components/mobile/案例/CasesCommonHeadMobile.vue";
import NextCaseButtonMobile from "@/components/mobile/案例/NextCaseButtonMobile.vue";

export default {
  name: "MobileJoyTouch",
  components: {NextCaseButtonMobile, CasesCommonHeadMobile}
}
</script>

<template>
  <div class="MobileJoyTouch">
    <CasesCommonHeadMobile :use-pic="true" :picurl="require('@/assets/picture/案例/JoyTouch/移动端Banner.png')" :arrow-url="require('@/assets/anime/案例首页线条-蓝绿色.mp4')" :title-color="'#2F5DC2'">
      <template #headerTitle>“虚实相生”的体验式新消费</template>
      <template #headerSlogan>交互设计｜界面设计｜品牌设计</template>
      <template #title1>成果</template>
      <template #content1>该项目已在2022年正式在重庆龙湖时代天街正式落地，创新的体验得到了广大消费者好评，成为行业瞩目的标杆性项目。</template>
      <template #title2>背景</template>
      <template #content2>以当代年轻人热捧的剧本杀消费为基本原型，用数字化技术（包括虚拟现实/区块链/NFT等）打造了一个全新的智慧实体体验门店，区别于一般的实体消费门店，进入该体验店之前需要选择一个剧本人物，有特殊的任务线。顾客扫码入店后进行开放式演绎与探索、社交，创造性的完成任务，体验虚拟角色的真实生活。</template>
    </CasesCommonHeadMobile>
    <div class="JoyTouchCustom">
      <div class="Container1">
        <div class="Top">
          <div class="Pic Pic1"></div>
          <div class="Pic Pic2"></div>
        </div>
        <div class="Bottom">
          <div class="Pic Pic3"></div>
        </div>
      </div>
      <div class="Container2">
        <div class="Content">
          <div class="Title3">建立<br>沉浸式的线上+线下体验</div>
          <div class="Text3">玩出花漾洞察线下的单点的娱乐方式市场疲软，创造年轻人更喜欢的沉浸、角色扮演的娱乐体验。通过小程序预定剧本虚拟角色，并且在线下换装体验实现虚拟与现实的全息演绎。</div>
        </div>
        <div class="Pics">
          <div class="PicContainer1">
            <div class="Pic Pic4"></div>
            <div class="Desc">玩家端体验线上沉浸式读本与查找线索</div>
          </div>
          <div class="Pic Pic5"></div>
        </div>
      </div>
      <div class="Container3">
        <div class="Content">
          <div class="Title4">通过设计<br>营造“写实”的视觉风格</div>
          <div class="Text4">如何将真实读本的视觉在界面设计中体现，以让用户感受到实际线下的沉浸体验。意谷在设计中运用了陈旧的纸质化表现形式当作玩家端剧本，更真实的线索搜集样式，来体现“写实”的视觉风格。</div>
        </div>
        <div class="Pic Pic6"></div>
      </div>
      <div class="NextContainer">
        <router-link to="/mobileCase/case006"><NextCaseButtonMobile></NextCaseButtonMobile></router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/global.scss" as global;

@mixin flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@mixin picbox{
  border-radius: 12px;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center;
  };
}
@mixin margin{
  margin-top: calc(32vw / 3.93);
  margin-bottom: calc(32vw / 3.93);
}
@mixin titleColor{
  color: #2F5DC2;
}

.Pic {
  @include picbox;
}

.MobileJoyTouch {
  width: 100%;
  height: auto;
  .JoyTouchCustom {
    width: 100%;
    height: auto;
    padding-left: 4%;
    padding-right: 4%;
    .Container1 {
      width: 100%;
      height: calc(420vw / 3.93);
      @include margin;
      @include flex;
      .Top {
        width: 100%;
        height: calc(172vw / 3.93);
        @include flex;
        flex-direction: row;
        .Pic {
          width: calc(172vw / 3.93);
          height: 100%;
        }
        .Pic1 {
          background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch01.png");
        }
        .Pic2 {
          background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch02.png");
        }
      }
      .Bottom {
        width: 100%;
        height: calc(233vw / 3.93);
        .Pic3 {
          width: 100%;
          height: 100%;
          background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch03.png");
        }
      }
    }
    .Container2 {
      width: 100%;
      min-height: calc(676vw / 3.93);
      @include flex;
      @include margin;
      .Content {
        width: 100%;
        min-height: calc(96vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title3 {
          width: 42%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
          align-self: flex-start;
        }
        .Text3 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
          line-height: 133.33%;
        }
      }
      .Pics {
        width: 100%;
        height: calc(540vw / 3.93);
        @include flex;
        .PicContainer1 {
          width: 100%;
          height: calc(267vw / 3.93);
          @include flex;
          .Pic4 {
            width: 100%;
            height: calc(233vw /  3.93);
            background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch04.png");
          }
          .Desc {
            @include global.h4-vw-m;
            color: #4069C3;
          }
        }
        .Pic5 {
          width: 100%;
          height: calc(233vw / 3.93);
          background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch05.png");
        }
      }
    }
    .Container3 {
      width: 100%;
      height: calc(385vw / 3.93);
      @include flex;
      @include margin;
      .Content {
        width: 100%;
        min-height: calc(96vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title4 {
          width: 42%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
          align-self: flex-start;
        }
        .Text4 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
          line-height: 133.33%;
        }
      }
      .Pic6 {
        width: 100%;
        height: calc(233vw / 3.93);
        background-image: url("@/assets/picture/案例/JoyTouch/JoyTouch06.png");
      }
    }
    .NextContainer {
      @include margin;
      width: 100%;
      height: calc(44vw / 3.93);
      padding-left: 17%;
      padding-right: 17%;
    }
  }
}
</style>